<template>
	<span class="tiempo-restante" content="Una vez transcurrido el tiempo, tus entradas se liberarán" v-tippy="{ placement: 'right', arrow: true }">
		<i class='bx bx-stopwatch'></i>
		{{ String(times[2].time).padStart(2, '0') }}:{{ String(times[3].time).padStart(2, '0') }}
	</span>
</template>

<script>
	const moment = require('moment');

	export default {
		props: ['trnfechafin'],
		data(){
			return {
				/* Tiempo restante */
				timeinterval: undefined,
				times: [
					{ id: 0, text: "Días", time: 0 },
					{ id: 1, text: "Horas", time: 0 },
					{ id: 2, text: "Minutos", time: 14 },
					{ id: 3, text: "Segundos", time: 59 }
				]
			}
		},
		computed: {
			expiroTiempo: function(){
				if(this.times[0].time <= 0 && this.times[1].time <= 0 && this.times[2].time <= 0 && this.times[3].time <= 0){
					return true
				} else {
					return false
				}
			},
		},
		watch: {
			expiroTiempo: function(){
				if(this.expiroTiempo === true){
					this.$emit('expirotiempo');
				}
			}
		},
		created: function(){
			this.updateTimer();
			this.timeinterval = setInterval(this.updateTimer, 1000);
		},
		methods: {
			updateTimer() {
				if (
					this.times[3].time > 0 ||
					this.times[2].time > 0 ||
					this.times[1].time > 0 ||
					this.times[0].time > 0
				) {
					this.getTimeRemaining();
				} else {
					clearTimeout(this.timeinterval);
				}
			},
			getTimeRemaining() {
				const horaActual = moment(new Date()).utc(0).format('YYYY-MM-DDTHH:mm:ss');
				let t = Date.parse(new Date(this.trnfechafin)) - Date.parse(horaActual);

				if(t >= 0) {
					this.times[3].time = Math.floor(t / 1000 % 60); //seconds
					this.times[2].time = Math.floor(t / 1000 / 60 % 60); //minutes
					this.times[1].time = Math.floor(t / (1000 * 60 * 60) % 24); //hours
					this.times[0].time = Math.floor(t / (1000 * 60 * 60 * 24)); //days
				} else {
					this.times[3].time = this.times[2].time = this.times[1].time = this.times[0].time = 0;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tiempo-restante{
		@include flex(row, space-between, center);
		padding: 4px 8px;
		background-color: #ccc;
		border-radius: 22px;
		font-weight: var(--fw-600);
		font-size: 13px;
		width: 72px;

		i{
			margin-right: 3px;
		}
	}

	.tiempo-restante-aclaracion{
		font-size: 11px;
		margin-top: 5px;
		font-weight: var(--fw-400);
		line-height: 1em;
	}
</style>